import React, { useEffect, useState } from "react";
import { Link as RouterLink, useParams } from "react-router-dom";
import {
  Alert,
  Box,
  Link,
  Paper,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import axiosClient from "../api/axiosClient";
import DataTable from "../components/brand/DataTable";
import Layout from "../components/layout/Layout";
import { useBreadcrumb } from "../context/BreadcrumbContext";

export default function PropertyUserAccessPage() {
  const { propertyId, userId } = useParams();
  const { setCustomPath, clearCustomPath } = useBreadcrumb();
  const [payload, setPayload] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    let cancelled = false;
    axiosClient
      .get(`/properties/${propertyId}/users/${userId}/access/`)
      .then((response) => {
        if (!cancelled) setPayload(response.data);
      })
      .catch((err) => {
        if (!cancelled) setError(err.response?.data?.error || "Could not load this user.");
      });
    return () => {
      cancelled = true;
    };
  }, [propertyId, userId]);

  useEffect(() => {
    if (!payload) return undefined;
    setCustomPath([
      { label: "Properties", path: "/properties" },
      { label: payload.property?.name || "Property", path: `/properties/${propertyId}/details?tab=access` },
      { label: payload.user?.name || payload.user?.email || "User", path: null },
    ]);
    return () => clearCustomPath();
  }, [payload, propertyId, setCustomPath, clearCustomPath]);

  return (
    <Layout>
      <Box sx={{ maxWidth: 1100, mx: "auto", p: 3 }}>
        <Link component={RouterLink} to={`/properties/${propertyId}/details?tab=access`} sx={{ display: "inline-block", mb: 2 }}>
          Property access
        </Link>
        {error && <Alert severity="error">{error}</Alert>}
        {payload && (
          <Paper elevation={2} sx={{ p: 3, borderRadius: 2 }}>
            <Typography variant="h4" fontWeight={700}>{payload.user?.name || payload.user?.email}</Typography>
            <Typography color="text.secondary" sx={{ mb: 2 }}>{payload.user?.email}</Typography>
            <Typography sx={{ mb: 3 }}>
              <strong>Global role:</strong> {payload.global_role || "None"}
            </Typography>
            <DataTable size="small">
              <TableHead>
                <TableRow>
                  <TableCell>Property</TableCell>
                  <TableCell>Staff role</TableCell>
                  <TableCell>Units</TableCell>
                  <TableCell>Open invites</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {(payload.properties || []).length === 0 && (
                  <TableRow>
                    <TableCell colSpan={4}>No property access you can see.</TableCell>
                  </TableRow>
                )}
                {(payload.properties || []).map((row) => (
                  <TableRow key={row.property_id}>
                    <TableCell>{row.property_name}</TableCell>
                    <TableCell>{row.staff_role || "—"}</TableCell>
                    <TableCell>{(row.units || []).map((unit) => unit.unit_name).join(", ") || "—"}</TableCell>
                    <TableCell>{(row.invites || []).map((invite) => invite.email).join(", ") || "—"}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </DataTable>
          </Paper>
        )}
      </Box>
    </Layout>
  );
}
